import React from 'react';
import doctorImage from '../../assets/doctor_img2.jpeg'

const DrAeshaEducationSection = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-16 bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        {/* Left Image */}
        <div>
          <div className="relative">
            {/* Decorative elements */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-lime-400 rounded-full opacity-20 z-0"></div>
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-teal-400 rounded-full opacity-20 z-0"></div>
            
            <img
              src={doctorImage}
              style={{maxHeight: '500px'}}
              alt="Doctor consulting with patient"
              className="w-full rounded-lg shadow-lg object-cover relative z-10 border-4 border-white"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="space-y-8">
          {/* Top Border */}
          <div className="w-full border-t-2 border-teal-100"></div>
          
          {/* Education Section */}
          <div className="space-y-6">
            <div className="flex items-center">
              <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center mr-3">
                <svg className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838l-2.328.996.002 1.069c0 .54.48.98 1.022.98h.006a1 1 0 00.988-.822l.601-3.516a.99.99 0 00-.429-.975l1.148-.491 2.639 1.129a1 1 0 00.788 0l7-3a1 1 0 000-1.84l-7-3zM3.31 11.397a1 1 0 011.354-.44l.292.125v3.418a1 1 0 01-2 0v-2.167l.354-.936zM18 10a1 1 0 01-1 1h-3.5a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5H17a1 1 0 010 2h-1.5v.5H17a1 1 0 010 2h-1.5v.5H17a1 1 0 010 2h-1.5v.5H17a1 1 0 110 2h-3.5a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5H17a1 1 0 011 1z"></path>
                </svg>
              </div>
              <h2 className="text-4xl font-serif text-teal-600">
                Education
              </h2>
            </div>
            
            <ul className="space-y-6 text-gray-700 pl-6">
              <li className="relative">
                <div className="absolute -left-6 top-2 w-3 h-3 bg-lime-500 rounded-full"></div>
                <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-lime-500 hover:shadow-md transition-shadow">
                  <span className="block text-lg font-medium text-teal-700">Bachelor of Dental Surgery</span>
                  <span className="text-gray-600">CDSH, Rau, Indore</span>
                </div>
              </li>
            </ul>
            
            <div className="pt-4">
              <button className="px-6 py-3 bg-white border-2 border-teal-500 text-teal-600 hover:bg-teal-50 rounded-lg shadow transition-colors inline-flex items-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 7v10m5-5H7"></path>
                </svg>
                View Full Credentials
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrAeshaEducationSection;